import React, { Component, useEffect, useState } from 'react';
import NotificationsView from './NotificationsView';
import crmservices from '../../wsclient/crmservices';
import Loading from '../../components/Loading';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import NotificationDetailView from './NotificationDetailView';

function Notifications(props) {

    const [showLoading, onShowLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [paging, setPaging] = useState({
        page: 0
    });
    const [removeItems, setRemoveItems] = useState([]);
    const [notification, setNotification] = useState(null);
    const [showDetail, setShowDetail] = useState(false);
    useEffect(()=>{
        onLoadNotification()
    },[]);

    const addItemToRemove = (item) =>{
        let newRemoveItems = [...removeItems];
        if(newRemoveItems.length == 0){
            newRemoveItems.push(item);
        }else{
            var indexItemExist = null;
            var itemExist = newRemoveItems.filter((i,index) => {
                if(i.id == item.id){
                    indexItemExist = index;
                    return i
                }
            })
            if(itemExist && itemExist.length > 0 && indexItemExist!=null){
                newRemoveItems.splice(indexItemExist, 1);
            }else{
                newRemoveItems.push(item);
            }
        }
       // console.log('newRemoveItems===', newRemoveItems)
        setRemoveItems(newRemoveItems);
    }
    const clearRemoveItem = () =>{
        setRemoveItems([]);
    }
    const onDeleteMultiNotification = async() =>{
        onShowLoading(true);
        try{
            if(removeItems.length > 0){
                for(let i=0;i< removeItems.length;i++){
                    await crmservices.communications.deleteCommunication(removeItems[i].id);
                }
                var result = await crmservices.communications.getCommunications();
                if (result.code == 'OK') {
                    setNotifications(result.data.content);
                    setPaging(result.data.paging);
                    if ( result.data.paging && result.data.paging.size < 10){
                        setHasMore(false);
                    }
                }
                clearRemoveItem();
                onShowLoading(false);
                return true;
            }else{
                showAlert(t('ERROR'),t('Please select notification to remove'));
                return false;
            }
        }catch(error){
            console.log("onDeleteMultiNotification error: ", error);
            showAlert(t('ERROR'),t('EXCEPTION_PROCESS'));
            return false;
        }
    }
    
    const onLoadNotification = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.communications.getCommunications();
           // console.log('onLoadNotification result====',result)
            if (result.code == 'OK') {
                setNotifications(result.data.content);
                setPaging(result.data.paging);
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("on load notification exception:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async() =>{
        onShowLoadMore(true);
        try {
            var result = await crmservices.communications.getCommunications({page: paging.page+1 });
            //console.log('onLoadNotification handleLoadMore== ',result)
            if (result.code == 'OK') {
                setNotifications([...notifications,...result.data.content])
                setPaging(result.data.paging)
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false)
                }
            }
        } catch (error) {
            console.log("on load wallet info error:", error);
        }
        onShowLoadMore(false);
    }
    const onShowDetail = async(data) =>{
        onShowLoading(true);
        try {
            await crmservices.communications.setRead(data.id);
            props.refreshNotificationForHeader()
            var result = await crmservices.communications.getCommunications();
            if (result.code == 'OK') {
                setNotifications(result.data.content);
            }
        } catch (error) {
            console.log("on show detail exception:",error);
        }
        onShowLoading(false);
        setShowDetail(true);
        setNotification(data)
    }
    const onDeleleNotification = async(id) =>{
        onShowLoading(true)
        try {
            var result = await crmservices.communications.deleteCommunication(id);
            if(result.code==='OK'){
                props.refreshNotificationForHeader()
                var result = await crmservices.communications.getCommunications();
                if (result.code == 'OK') {
                    setNotifications(result.data.content);
                }
            }else{
                showAlert(t('ERROR'),t('remove_notification_failed'));
            }
        } catch (error) {
            console.log("Notification Detail onRefresh: ", error);
            showAlert(t('ERROR'),t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = () =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        })
    }
    //console.log('state removeItems====', removeItems)
    return (
        <div>
            <NotificationsView
                    open = {props.open} 
                    onClose = {()=>props.onClose('notifications')}
                    notifications={notifications}
                    showLoading={showLoading}
                    handleLoadMore={handleLoadMore}
                    onShowDetail = {onShowDetail}
                    onDeleleNotification = {onDeleleNotification}
                    showLoadMore = {showLoadMore}
                    hasMore = {hasMore}
                    removeItems={removeItems}
                    addItemToRemove={addItemToRemove}
                    clearRemoveItem={clearRemoveItem}
                    onDeleteMultiNotification={onDeleteMultiNotification}/>
            {showDetail&&<NotificationDetailView
                    open = {showDetail}
                    onClose = {()=>setShowDetail(false)}
                    item = {notification}
                    />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}

export default Notifications;